import React from "react";
import Logo from "../assets/FooterLogo.png"


const Footer = ()=>{

    return(
        <footer className="w-full flex bg-footer-background bg-cover bg-center mt-16 pb-10 font-guton">
            <div className="flex justify-between w-90 mx-auto ">
                <div className="flex-col">
                    <a href="/"><img className="w-[100px] md:w-[150px] xl:w-[300px] md:mb-6 xl:mb-8" src={Logo} alt="Logo" /></a>
                    <h2 className="text-14 leading-14 my-4 md:text-36 xl:text-64 font-medium md:leading-32 xl:leading-55 text-white tracking-[-1px] md:tracking-[-3px]">Ready to Join<br /> Hundreds of Students?</h2>
                    <div className="md:mt-10 xl:mt-20 flex justify-between w-[120px] md:w-45 xl:w-45 opacity-70">
                        <a className="text-8 md:text-12 xl:text-20 text-white" href="/aboutus">About Us</a>
                        <a className="text-8 md:text-12 xl:text-20 text-white" href="/poland">Poland</a>
                        <a className="text-8 md:text-12 xl:text-20 text-white" href="/services">Services</a>
                    </div>
                </div>
                <div className="flex flex-col items-end">
                    <p className="hidden md:block md:text-18 xl:text-32 text-white md:leading-18 xl:leading-32 text-right">We'll Guide You<br /> Through It All.</p>
                    <div className="flex w-fit text-8 md:text-18 xl:text-32 md:mt-6">
                        <a href="https://wa.link/eaoxxu" target="_blank" rel="noopener noreferrer" className="flex font-guton bg-custom-gradient text-white px-3 md:px-5 xl:px-8 rounded-full py-1 md:py-2 xl:py-3 md:leading-18 xl:leading-30 hover:text-black hover:bg-custom-white transition duration-500 ease-in-out">Study Abroad</a>
                    </div>
                    <p className="hidden md:block md:text-12 xl:text-20 text-white mt-auto opacity-70">© Estudy Agency 2025. All Rights Reserved.
                    </p>
                </div>

            </div>

        </footer>
    )
}

export default Footer;